export interface User {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  enabled: boolean;
  realmRoles: UserRole[];
}

export type UserRole =
  | 'assistant-de-production'
  | 'administration-du-personnel'
  | 'responsable-exploitation'
  | 'directeur-rh'
  | 'responsable-rh'
  | 'responsable-paie'
  | 'directeur-agence'
  | 'directeur-admin-financier'
  | 'directeur-general'
  | 'directeur-production'
  | 'cdt-process-manager';

export const realmRoles: UserRole[] = [
  'assistant-de-production',
  'administration-du-personnel',
  'responsable-exploitation',
  'responsable-paie',
  'directeur-rh',
  'responsable-rh',
  'directeur-agence',
  'directeur-admin-financier',
  'directeur-general',
  'directeur-production',
];

/**
 * Régler les processus CDT — aujourd'hui les notifications — relève du directeur général et du
 * directeur RH ; le rôle `cdt-process-manager` en donne le droit à une autre personne, et n'habilite
 * qu'à cela (RG-notification-droit-de-regler). Il n'entre pas dans `realmRoles` : il ne désigne
 * aucune fonction.
 */
export const processSettingsEditorRoles: UserRole[] = [
  'directeur-general',
  'directeur-rh',
  'cdt-process-manager',
];
